/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useMemo } from 'react';
import block from 'bem-cn';

import MuiPagination from '@mui/material/Pagination';

import './Pagination.scss';

type PaginationProps = {
  activePage: number
  onClick: (a: any) => void
  limit: number
  size?: any
  total: number
  ellipsis?: boolean
  maxButtons?: number
}

const b = block('pagination')

const Pagination: React.FC<PaginationProps> = ({ activePage, onClick, limit, total, ...props }) => {
  const pagesCount = useMemo(() => Math.ceil(total / limit), [total, limit])

  const handleChangePage = useCallback(
    (e: React.ChangeEvent<unknown>, value: number) => {
      onClick(value)
    },
    [onClick],
  )

  if (pagesCount < 2) return null

  return (
    <div className={b()}>
      <MuiPagination
        page={activePage}
        onChange={handleChangePage}
        count={pagesCount}
        variant="outlined"
        shape="rounded"
        {...props}
      />
    </div>
  )
}

export default Pagination
